export function emptyFieldEventSummary() {
  return {
    fuelCount: 0,
    totalLiters: 0,
    avgLitersPerStop: 0,
    assumeCount: 0,
    finishCount: 0,
    photoCount: 0,
    operatorCount: 0,
  };
}

export function normalizeFieldEventSummary(raw) {
  if (!raw) return emptyFieldEventSummary();
  return {
    fuelCount: Number(raw.fuelCount) || 0,
    totalLiters: Number(raw.totalLiters) || 0,
    avgLitersPerStop: Number(raw.avgLitersPerStop) || 0,
    assumeCount: Number(raw.assumeCount) || 0,
    finishCount: Number(raw.finishCount) || 0,
    photoCount: Number(raw.photoCount) || 0,
    operatorCount: Number(raw.operatorCount) || 0,
  };
}

export function eventTypeIcon(type) {
  if (type === "fueling") return "⛽";
  if (type === "assume_machine") return "🚜";
  if (type === "finish_work") return "✓";
  return "▶";
}
